import {Breadcrumb, Button} from '@/components/atoms'
import {PageHeader} from '@/components/molecules'
import {usePromotionTypes} from '@/hooks/usePromotionTypes'
import {FONT_SIZE} from '@/utils/constants/globalStyle'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useNavigate} from 'react-router-dom'

const breadcrumbUISchema = [
  {
    href: '/',
    label: '',
  },
  {
    href: ROUTES.SELECT_PROMOTION_TYPE,
    label: 'Promotions',
  },
  {
    href: ROUTES.CREATE_PROMOTION,
    label: 'Create Promotion',
  },
]

const PromotionTypeCard = ({promotion}) => {
  const navigate = useNavigate()

  const handleCreateNewPromotion = () => {
    navigate(ROUTES.CREATE_PROMOTION, {
      state: {
        promotionType: promotion.type,
      },
    })
  }

  const handleCopyPromotion = promotionId => {
    navigate(ROUTES.CREATE_PROMOTION, {
      state: {
        promotionId,
        isDuplicating: true,
      },
    })
  }

  return (
    <div
      className="flex flex-col justify-between gap-6 rounded-xl bg-[#1D1D1D] p-4 text-white"
      data-testid={`promotion-card-${promotion.type}`}
    >
      <div>
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-bold text-[#EFEFEF]">{promotion.title}</h3>
            <p className="mt-1 text-base italic text-[#D0D0D0]">{promotion.description}</p>
          </div>
          <div className="flex-shrink-0">
            <Button
              handleButton={handleCreateNewPromotion}
              uiSchema={{
                variant: 'secondary',
                isDark: true,
                size: 'medium',
                iconTrailing: 'chevron_right',
                className: '',
              }}
            >
              {'Start New'}
            </Button>
          </div>
        </div>
      </div>
      {promotion.latestPromotionName && (
        <div data-testid="recent-promotion">
          <Button
            uiSchema={{
              variant: 'secondary',
              isDark: true,
              size: 'large',
              iconTrailing: 'chevron_right',
              className:
                'justify-between !w-full rounded-[16px] border !border-[#4E4E4E] !text-[#D0D0D0] hover:bg-[#1D1D1D] !px-[16px] fw-400',
            }}
            handleButton={() => handleCopyPromotion(promotion.latestPromotionId)}
          >
            {promotion.latestPromotionName}
          </Button>
        </div>
      )}
    </div>
  )
}

const SelectPromotionType = () => {
  const {promotionTypes, isLoading, error} = usePromotionTypes()
  if (isLoading) {
    return <div className="flex min-h-screen items-center justify-center bg-black text-white">Loading...</div>
  }

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-black text-white">
        Error loading promotion types
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="container mx-auto">
        <Breadcrumb
          uiSchema={{
            isDark: true,
            breadcrumbs: breadcrumbUISchema,
          }}
          id={'promotion-breadcrumb'}
        />
        <div className="px-4 pb-8 pt-4">
          <PageHeader title="Select Promotion Type" fontSize={FONT_SIZE.XXXL} />
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            {promotionTypes?.map(promotion => (
              <PromotionTypeCard key={promotion.type} promotion={promotion} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectPromotionType
